import { buildAppUrl } from './appBase';

/**
 * Build a shareable client link (plan invite + optional offer deep-link).
 */
export function buildClientInviteShareUrl(inviteCode: string, offerId?: number): string {
	const params = new URLSearchParams({ invite: inviteCode });
	if (offerId != null && offerId > 0) {
		params.set('offer_id', String(offerId));
	}
	return buildAppUrl(`?${params.toString()}`);
}

export function buildClientInviteShareMessage(
	inviteUrl: string,
	copy: (en: string, de: string, hr: string) => string,
	options?: { forQuote?: boolean }
): string {
	if (options?.forQuote) {
		return copy(
			`Hey! A garden company shared a quote with you on HortEra:\n${inviteUrl}\n\nLog in or sign up through this link to review and respond.`,
			`Hallo! Ein Gartenunternehmen hat eine Offerte mit dir auf HortEra geteilt:\n${inviteUrl}\n\nMelde dich über diesen Link an oder registriere dich, um sie zu prüfen und zu antworten.`,
			`Bok! Vrtna tvrtka podijelila je ponudu s tobom na HortEri:\n${inviteUrl}\n\nPrijavi se ili registriraj putem ove poveznice da je pregledaš i odgovoriš.`
		);
	}
	return copy(
		`Hey! A garden plan was shared with you on HortEra:\n${inviteUrl}\n\nLog in or sign up through this link to view it.`,
		`Hallo! Ein Gartenplan wurde mit dir auf HortEra geteilt:\n${inviteUrl}\n\nMelde dich über diesen Link an oder registriere dich, um ihn zu sehen.`,
		`Bok! Vrtni plan je podijeljen s tobom na HortEri:\n${inviteUrl}\n\nPrijavi se ili registriraj putem ove poveznice da ga vidiš.`
	);
}
